import React, { useEffect, useState } from "react";

type HeroIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export default function FloatingCallToAction({
  label,
  Icon,
  onClick,
  disabled = false,
  className = "",
  colorClassName = "bg-primary-600 hover:bg-primary-700 focus:ring-primary-400",
  shouldEnterAnimate = false,
}: {
  label: string;
  Icon: HeroIcon;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  colorClassName?: string; // 👈 pass tailwind color classes here
  shouldEnterAnimate?: boolean; // 👈 slide in on mount
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        "fixed bottom-4 right-4 z-50",
        "inline-flex items-center gap-2",
        "rounded-full px-4 py-3",
        "!text-white shadow-lg",
        "active:scale-[0.99]",
        "focus:outline-none focus:ring-2 focus:ring-offset-2",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        shouldEnterAnimate ? "cta-enter" : "",
        colorClassName,
        className,
      ].join(" ")}
    >
      <Icon className="h-5 w-5 !text-white z-10" aria-hidden="true" />
      <span className="text-sm font-semibold whitespace-nowrap z-10">{label}</span>
    </button>
  );
}
